
import {
  Factory as ListingsRowsCarousel,
} from "concepts/listings/rows/carousel"
import ListingsRowCardDefault from "concepts/listings/row/card/default"

const init = () => {
  ListingsRowsCarousel.create({
    scope: ".page-section-rental_listings",
  })
  ListingsRowCardDefault.init()
}


export default {
  init: init,
}
